module.exports = __webpack_public_path__ + "museosans700-webfont.de86a6c9f002842a7bb8.woff";


//////////////////
// WEBPACK FOOTER
// D:/api-fronted/css/fonts/museosans700-webfont.woff
// module id = ../../../../../css/fonts/museosans700-webfont.woff
// module chunks = styles